import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowDropDownRounded as ArrowDropDownRoundedIcon } from '@mui/icons-material';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import { getLocalizedTitle } from '@src/services/educatorsSurvey';
import { StyledSelectPopover } from './index.style';

const QuestionSelect = ({
  question,
  placeholder,
  selectedOption,
  onSelect,
}) => {
  const { i18n } = useTranslation();
  const { language } = i18n;
  const [anchorEl, setAnchorEl] = useState(null);

  const handleSelect = (option) => {
    onSelect(option);
    setAnchorEl(null);
  };

  return (
    <div className="survey-select">
      <button
        type="button"
        className="survey-select-trigger"
        aria-haspopup="listbox"
        aria-expanded={Boolean(anchorEl)}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        <Typography variant="body-14-medium" color={COLOR.darkGray}>
          {selectedOption
            ? getLocalizedTitle(selectedOption.title, language)
            : placeholder}
        </Typography>
        <ArrowDropDownRoundedIcon className="survey-select-arrow" />
      </button>

      {/* A popover keeps the list out of the scrolling form, so its shadow is
          never clipped and a long list scrolls on its own. */}
      <StyledSelectPopover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        anchorWidth={anchorEl?.clientWidth}
      >
        <div role="listbox">
          {question.options.map((option) => (
            <button
              key={option.key}
              type="button"
              role="option"
              aria-selected={option.key === selectedOption?.key}
              className="survey-select-option"
              onClick={() => handleSelect(option)}
            >
              <Typography variant="body-14-medium" color={COLOR.darkGray}>
                {getLocalizedTitle(option.title, language)}
              </Typography>
            </button>
          ))}
        </div>
      </StyledSelectPopover>
    </div>
  );
};

export default QuestionSelect;
